import { render } from "./TradePreviewModalGP.vue?vue&type=template&id=f3192292&scoped=true&ts=true"
import script from "./TradePreviewModalGP.vue?vue&type=script&lang=ts"
export * from "./TradePreviewModalGP.vue?vue&type=script&lang=ts"

import "./TradePreviewModalGP.vue?vue&type=style&index=0&id=f3192292&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3192292"]])

export default __exports__